"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Welcome_Modal = void 0;

var noun_modal = void 0;

noun_modal = require("./noun_modal");

Welcome_Modal = function () {
	function Welcome_Modal() {
		(0, _jquery2.default)(".modal-overlay").on("click", function (e) {
			return noun_modal.dismiss();
		});
		(0, _jquery2.default)(".modal-overlay .inner").on("click", function (e) {
			return e.stopPropagation();
		});
	}

	return Welcome_Modal;
}();

exports.default = Welcome_Modal;